import * as React from 'react';
import { Accordion } from '@shared/ui-components';

import { Styled } from './styled';
import { getFAQList } from './subscription-faq-list';


export const SubscriptionFaq: React.FC = React.memo(() => {
  const FAQList = getFAQList();

  return (
    <Styled.Container>
      <Accordion
        title='FAQ'
        content={FAQList}
      />
    </Styled.Container>
  );
});
